import { AppData, Utils } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning";
import { Base, Icon } from "@lightningjs/ui-components";
import { AppState } from "../../lib/app-state";
import { AppSetup } from "../../lib/app-setup";
import { AppApiConfig, Channel } from "../../lib/app-api-config";
import { Log } from "@lightningjs/sdk";
import LoadingIcon from "./loading-icon";

export interface LoadingWidgetTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class LoadingWidget
  extends Lightning.Component<LoadingWidgetTemplateSpec>
  implements Lightning.Component<LoadingWidgetTemplateSpec>
{
  channel!: Channel
  _rotateAnimation = null
  static override _template(): Lightning.Component.Template<LoadingWidgetTemplateSpec> {
    return {
      x: 0,
      y: 0,
      w: 1920,
      h: 1080,
      rect: true,
      color: 0x00000000,
      flex: { alignItems: 'center', justifyContent: 'center' },
      Loading: undefined,
      zIndex: 10
    }
  }

  override _init() {
    Log.info('LoadingWidget:_init fired')
  }

  override _getFocused():
    | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
    | null
    | undefined {
    Log.info('LoadingWidget: _getFocused fired')
    return this
  }

  _removeChildrens() {
    this.patch({
      color: 0x00000000,
      Loading: undefined
    })
  }

  showLoadingScreen(state: boolean) {
    this._removeChildrens()
    if (state) {
      Log.info('LoadingWidget: showLoadingScreen: ')
      this.patch({
        color: 0xFF000000,
        Loading: {
          type: LoadingIcon
        }
      })
    } else {
      this._removeChildrens()
    }
  }

  showL1LoadingScreen(state: boolean) {
    const { appState, appConfig } = AppData as AppSetup
    const app = appState?.getApp()!

    const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!
    let bannerImg = ''
    //commenting the following code to disable L1 banner loading based on Ankita's suggestion.
    try{
      if(appApiConfig.appConfig.channels[app?.l1CategoryToLoad]){
       bannerImg = appApiConfig.appConfig.channels[app?.l1CategoryToLoad].bannerad_image
      }
    } catch(e){
    }

    if (bannerImg == '') { bannerImg = `${appConfig?.resouceUrl}splash-${appConfig?.siteId}.jpg` }
    // if (bannerImg == '') {
    //   this.showLoadingScreen(state)
    //   return
    // }
    this._removeChildrens()
    if (state) {
      Log.info('LoadingWidget: showL1LoadingScreen: ', bannerImg)
      this.patch({
        color: 0xFF000000,
        Loading: {
          flexItem: { margin: 0 },
          w: (w) => w,
          h: (h) => h,
          src: bannerImg
        }
      })
    } else {
      this._removeChildrens()
    }
  }

  showVideoLoadingScreen(state: boolean) {
    this._removeChildrens()
    if (state) {
      const { appState } = AppData as AppSetup
      const app = appState?.getApp()
      const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!
      const bannerImg = appApiConfig.appConfig.imageAdList.imgAd
      Log.info('LoadingWidget: showVideoLoadingScreen: ', bannerImg)
      this.patch({
        color: 0xFF000000,
        Loading: {
          flexItem: { margin: 0 },
          w: (w) => w,
          h: (h) => h,
          src: bannerImg
        }
      })
    } else {
      this._removeChildrens()
    }
  }
}
